export default __webpack_public_path__ + "static/media/imgs5.1e8c5d77.jpg";